import React from 'react';
import { BiMenu } from 'react-icons/bi';
import './headerSA.css';
import { CiLogout } from "react-icons/ci";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logoGc from "../../../imgs/logoGc.png";

const HeaderSA = ({ toggleSidebar, isActive ,logout}) => {
    return (
        <header className='header justify-content-around fixed-top' id="header">
            <div className="header_toggle text-light" onClick={toggleSidebar}> 
                <BiMenu id="header-toggle" />
            </div>
            <Link className="brand_link" to="/superDashboard">
                <Navbar.Brand className="brand">
                    <img src={logoGc} className='Logo-imageA' alt="logo-gecimmo" />
                </Navbar.Brand>
            </Link>
            <button className="Hbtn-logout btn btn-light" onClick={logout}>
                <CiLogout className='nav_icon' /> <span className="btn_text">Sign Out</span>
            </button>
        </header>
    );
};

export default HeaderSA;
